import React, { Component } from 'react';
import { connect } from 'react-redux';
import BacteriaChoice from './bacteria-choice';
import bacteriaInformation from '../config/bacteria-information';
import classnames from 'classnames';
import CircleWithBorder from '../components/circle-with-border';
import Squiggle from "./squiggle";
import HoverCircle from '../components/hover-circle';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

class ChooseABacteria extends Component {

    render() {
        const { isExiting, skip } = this.props;
        const classNames = classnames(
            'choose-a-bacteria',
            { 'exiting' : isExiting },
            { 'skipped' : skip || isMobile }
        );

        return (
            <div className={classNames}>
                <div className="circles">
                    <div className="choose-a-bacteria-circle-1">
                        <div className="choose-a-bacteria-decor">
                            <div className="animation-circle-dot" />
                            <Squiggle className="choose-a-bacteria-squiggle" />
                        </div>
                    </div>
                    <div className="choose-a-bacteria-circle-2" />
                    <div className="choose-a-bacteria-circle-3" />
                    <div className="choose-a-bacteria-circle-4" />
                    <div className="choose-a-bacteria-circle-5" />
                </div>
                <div className="bacteria-choices-container">
                    <div className="bacteria-choices">
                        { bacteriaInformation.map( (bacteria, key) => {
                            return (
                                <BacteriaChoice key={ "choice-"+key } order={ key + 1 } bacteria={ bacteria } />
                            );
                        })}
                    </div>
                </div>
                <div className="bacteria-choices-scale">
                    <strong>Scale</strong>
                    <div>0.000005 metres</div>
                </div>
                <div className="bacteria-choices-header">
                    <CircleWithBorder><h2>Select a Bacterium</h2></CircleWithBorder>
                </div>
                <HoverCircle />
            </div>
        );
    }

}

ChooseABacteria.defaultProps = {
    skip: false
};

ChooseABacteria.propTypes = {
    skip: PropTypes.bool
};

const mapStateToProps = ( state ) => {
    return {
        isExiting: state.animationStatus.isExiting
    };
};

export default connect(mapStateToProps)(ChooseABacteria);



// WEBPACK FOOTER //
// ./src/components/choose-a-bacteria.js